import { observer } from 'mobx-react';
import { CSSProperties } from 'react';

import styled from 'styled-components';
import { MediaQueryMobileOnly } from '../utils/constants';
import { usePrevious } from '../utils/utils';
import { store } from '../mobx/store';
import { Flex, VFlex } from './Flex';
import { STriangle } from './STriangle';

const SDiv = styled(Flex)`
white-space: nowrap;
justify-content: center;
`;

const SSmallText = styled(Flex)`
font-family: 'Inter';
font-style: normal;
font-weight: 400;
font-size: 20px;
line-height: 24px;
${MediaQueryMobileOnly} {
  font-size: 12px;
  line-height: 16px;
}
letter-spacing: -0.02em;
white-space: nowrap;

color: #615F5F;
justify-content: center;
`;


export const EquationLines = observer(({lines, style, isShowTriangle}:{lines:String[], style:CSSProperties, isShowTriangle:Boolean}) => {
  const prevLines:String[] = usePrevious(lines);
  if (!lines.map) {
    return (
      <SDiv>
        --
      </SDiv>
    );
  }
  return lines?.map((line, idx) => {
    if (typeof line !== 'string') return null;

    const numPart = line.split('\n')[0];
    const vFloat = parseFloat(numPart.replace(/,/gm, ''));

    let pl = prevLines && prevLines[idx];

    const prevNumPart = pl ? pl.split('\n')[0] : '';
    const prevVFloat = pl ? parseFloat(prevNumPart.replace(/,/gm, '')) : 0;

    const _style = style || {};

    if (!isNaN(vFloat) && !isNaN(prevVFloat)) {
      if (vFloat > prevVFloat) {
        _style.color = 'green';
      } else if (vFloat < prevVFloat) {
        _style.color = 'red';
      }
    }

    const C = idx > 0 ? SSmallText : SDiv;

    return (
      <VFlex
        style={{
          position: 'relative',
        }}
      >
        {/* {
          _style === 'green' ? (
            <Triangle />
          ) : (
            <Triangle />
          )
        } */}
        <C key={+idx + line} style={{..._style}}>
          {line?.includes('[ERROR]') && line !== '-'
            ? <img src="/warning.svg" alt="Disconnect" height={20} />
            : (
              isShowTriangle && _style.color && line && store.isDesktop
              && (
                <STriangle
                  size={15}
                  color={_style.color}
                  style={{
                    display: 'inline',
                    position: 'absolute',
                    left: -18,
                    transform: 'scaleY(0.7)' + (_style.color === 'red' ? ' rotate(180deg)' : ''),
                  }}
                />
              )
            )
          }
          {line?.includes('ERROR') ? '' : line}
        </C>
      </VFlex>
    );
  });
});
